import { APP_LOAD, LOAD_PROJECT, FETCH_PROJECTS, FETCH_PIXEL_SETS, FETCH_LINKS, FETCH_TAGS } from '../actions/actionTypes.js';
import { combineReducers } from 'redux'

const loadingReducer = (typeObj, defaultState = false) => {
  return (state = defaultState, action) => {
    switch (action.type) {
      case typeObj.START:
        return true;
      case typeObj.FAIL:
      case typeObj.SUCCESS:
        return false;
      default:
        return state;
    }
  }
}

export const loaders = combineReducers({
  app: loadingReducer(APP_LOAD, true),
  currentProject: loadingReducer(LOAD_PROJECT),
  projects: loadingReducer(FETCH_PROJECTS),
  pixelSets: loadingReducer(FETCH_PIXEL_SETS),
  links: loadingReducer(FETCH_LINKS),
  tags: loadingReducer(FETCH_TAGS)
});


// WEBPACK FOOTER //
// ./src/reducers/loaders.js